import instance from 'axios'
import HttpUtils from './httpUtils'

export const baseUrl = HttpUtils.getApi()
const axios = instance.create({
  baseURL: baseUrl
})

export default axios
